<script>
export default {
	props: {
		items: Array,
		gap: [String, Number],
		position: String,
		fluid: Boolean,
		noPadding: Boolean,
		containerMinHeight: [String, Number],
		noMenuCalculatedWidth: Boolean,
	},
	computed: {
		appbarType() {
			return this.$srv('AppBarConfig.type')
		},
	},
	methods: {
		makeIconOptions(item) {
			return {
				iconType: item.iconType,
				icon: item.icon,
				iconHtml: item.iconHtml,
				iconImage: item.iconImage,
			}
		},
		makeButtonOptions(item) {
			return {
				hideText: item.buttonHideText,
				iconColor:
					item.buttonIconColor ||
					(this.position == 'top' ? this.$vars.basetext : this.$vars.primarytext),
				btnClass: item.dense ? 'px-1' : 'px-2',
				iconSize: item.dense ? 20 : 25,
				class: 'appbar__button',
				iconOptions: this.makeIconOptions(item),
			}
		},
		makeComponentProps(item) {
			let res
			switch (item.type) {
				case 'logo':
					res = {
						logo: item.logo,
						logoAlt: item.logoAlt || null,
						is: 'AppBar-Logo',
					}
					break
				case 'search':
					res = {
						is: 'AppBarSearch',
						useSearchDialog: item.useSearchDialog,
						iconColor:
							item.buttonIconColor ||
							(this.position == 'top' ? this.$vars.basetext : this.$vars.primarytext),
						iconOptions: this.makeIconOptions(item),
						iconSize: item.dense ? 20 : 25,
					}
					break
				case 'buttonLogin':
					res = {
						is: 'AppBar-ButtonLogin',
						...this.makeButtonOptions(item),
					}
					break
				case 'buttonWishlist':
					res = {
						is: 'AppBar-ButtonWishlist',
						...this.makeButtonOptions(item),
					}
					break
				case 'buttonCart':
					res = {
						is: 'AppBar-ButtonCart',
						...this.makeButtonOptions(item),
					}
					break
				case 'allBrands':
					res = {
						is: 'AppBar-AllBrands',
						dense: item.dense,
						iconType: item.iconType,
						icon: item.icon,
						iconHtml: item.iconHtml,
						iconImage: item.iconImage,
						text: item.text,
						transparent: this.appbarType == 'transparent',
					}
					break
				case 'megaMenu':
					res = {
						is: 'CategoriesMegaMenu',
						items: this.$srv('MegaMenu', []),
						appBarConfigType: this.appbarType,
						roundAppBarMenuLocation: this.$srv('AppBarConfig.roundAppBarMenuLocation'),
						btnText: this.$srv('AppBarConfig.megaMenuBtnText'),
						noBg: this.appbarType == 'transparent',
					}
					break
				case 'link':
					res = { is: 'AppBar-Link', transparent: this.appbarType == 'transparent', ...item }
					break
				case 'megaMenuHorizontal':
					res = {
						is: 'AppBar-DropdownMenu',
						megaMenuHorizontalId: item.megaMenuHorizontalId,
						transparent: this.appbarType == 'transparent',
						noCalculatedWidth: this.noMenuCalculatedWidth,
					}
					break
				case 'imagesCarousel':
					res = {
						is: 'AppBarComposableRow-ImagesCarousel',
						data: item,
						transparent: this.appbarType == 'transparent',
					}
					break
				case 'spacer':
					res = { is: 'div' }
					break
				case 'categoriesList': {
					res = {
						is: 'AppBar-Bottom-CategoriesMenu',
						categories: this.$srv('AppBarComposableRow.categories', []),
						attach: `#composable-appbar-${this.position}`,
					}
					break
				}
				default:
					res = {}
			}
			res.class = (res.class || '').concat(' ').concat(item.cssClass || '')
			res.style = (res.style || '').concat(' ').concat(item.cssStyle || '')
			return res
		},
		makeComponentListeners(item) {
			switch (item.type) {
				case 'categoryMenu':
					return {
						open: (item) => {
							this.activeCategoryMenu = item
						},
						close: (item) => {
							if (this.activeCategoryMenu?.id == item.id) {
								this.activeCategoryMenu = null
							}
						},
					}
				default:
					return null
			}
		},
	},
	cssVars: {
		selector: '.appbar',
	},
}
</script>

<template>
	<div class="appbar">
		<v-container
			:class="['d-flex align-center', { 'pa-0': noPadding }]"
			:style="{ gap: gap && `${gap}px`, 'min-height': containerMinHeight + 'px' }"
			:fluid="fluid"
			style="position: relative"
			:id="`composable-appbar-${position}`"
		>
			<!-- eslint-disable-next-line vue/require-component-is -->
			<component
				v-for="(item, i) in items"
				:key="i"
				class="h100"
				v-bind="makeComponentProps(item)"
				v-on="makeComponentListeners(item)"
			/>
		</v-container>
	</div>
</template>

<style scoped lang="scss">
.fill-available {
	height: -webkit-fill-available;
}
</style>

